import { createSlice } from "@reduxjs/toolkit";
import { GeneralCategory, Loading, ProductsRepository } from "../domain";
import { ServiceLocater, Services } from "../service-locater";
import { AppThunk } from "./store";

type CategoriesState = {
  generalCategories: GeneralCategory[];
  loading: Loading;
};

const initialState: CategoriesState = {
  generalCategories: [],
  loading: "idle",
};

const categoriesSlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    categoriesLoading(state) {
      state.loading = "pending";
    },
    categoriesLoaded(state, { payload }) {
      state.generalCategories = payload;
      state.loading = "succeeded";
    },
    categoriesFailed(state) {
      state.loading = "failed";
    },
  },
});

export default categoriesSlice.reducer;

const {
  categoriesFailed,
  categoriesLoaded,
  categoriesLoading,
} = categoriesSlice.actions;

export const loadCategories = (): AppThunk => async (dispatch, getState) => {
  const { loading } = getState().categories;
  if (loading !== "pending" && loading !== "succeeded") {
    dispatch(categoriesLoading());
    const res = await ServiceLocater.get<ProductsRepository>(
      Services.ProductsRepository
    ).getCategories();
    res.fold(
      (_) => dispatch(categoriesFailed()),
      (r) => dispatch(categoriesLoaded(r))
    );
  }
};
